module.exports = __webpack_public_path__ + "img/new-update-icon.8fbddddd.svg";